// extracted by mini-css-extract-plugin
export default {"logout-modal":"styles_logout-modal__ZkdBM","logout-modal__close":"styles_logout-modal__close__AiI3E","logout-modal__buttons":"styles_logout-modal__buttons__27YbI"};